import { initReactI18next } from 'react-i18next';
import { dealDe, dealEn, dealIt } from '@guryou/translations';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const language = localStorage.getItem('language') || 'it';

/** Repo JSON wins over S3 after xhr merges (shallow merge would drop new PROFILE keys). */
const mergeDealBundlesFromRepo = () => {
  i18n.addResourceBundle('en', 'deal', dealEn, true, true);
  i18n.addResourceBundle('it', 'deal', dealIt, true, true);
  i18n.addResourceBundle('de', 'deal', dealDe, true, true);
};

i18n.on('loaded', mergeDealBundlesFromRepo);

i18n
  .use(detector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init(
    {
      ns: ['deal', 'landing'],
      defaultNS: 'deal',
      lng: language,
      fallbackLng: false,
      resources: {
        en: { deal: dealEn },
        it: { deal: dealIt },
        de: { deal: dealDe },
      },
      react: {
        useSuspense: false,
      },
      backend: {
        loadPath: `${process.env.REACT_APP_S3_TRANSLATIONS_URL}/{{ns}}/{{lng}}.json`,
        allowMultiLoading: false,
        crossDomain: false,
        withCredentials: false,
        load: 'currentOnly',
        backendOptions: {
          expirationTime: 0,
        },
      },
      interpolation: {
        escapeValue: false,
      },
    },
    mergeDealBundlesFromRepo
  );

export default i18n;
